import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 bottom-0 zIndex h-full w-full bg-dark/10" }
const _hoisted_2 = { class: "h-full flex justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(`${_ctx.sizeLarge
      ? 'lds-ripple-size-large lds-ripple-effect-large'
      : 'lds-ripple-size-small lds-ripple-effect-small'
      } lds-border`)
      }, _hoisted_6, 2)
    ])
  ]))
}